<template src="./registration.html"></template>

<script>
import Vue from 'vue'
import $api2 from '@/plugins/axiosInstance2'
import isEmpty from 'lodash/isEmpty'
import optionData from '@/optionData/data'
import _ from 'lodash'
import flatten from 'flat'
import {ko} from 'vuejs-datepicker/dist/locale'

export const BtnSelect = Vue.extend({
  name : 'btnSelect',
  template: `
       <vs-button class="btnSmall" @click="btnClickedHandler()" color="success" type="filled">선택</vs-button>
    `,
  data(){
    return{
      title : ''
    }
  },
  created(){
    this.title = this.params.colDef.headerName
    
  },
  methods: {
    btnClickedHandler() {
      this.params.clicked(this.params.data);
    }
  },
});
export default {
    name: "artistRegistration",
    data() {
      return {
        fileUrl: `${process.env.VUE_APP_API_URL}/file`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('srAccessToken')}`,
          'Access-Control-Allow-Origin': '*',
        },
        ko : ko,
        selectLicensor : [],
        memberOption : optionData.memberKeyword,
        page: {
          pageSize : 10,
          currentPage: 1,                       // 현재 페이지
          totalPage: 0,                         // 총 페이지수
        },
        sns : [], 
        snsUrl : null,
        selectSns : null,
        snsOption : optionData.sns, 
        display_name : null ,
        display_name_language : 'ko',
        display_name_english: null,
        name_multilang : {},
        name_export : {},

        nationality : null,
        countryOption : optionData.country,
        artistType : null,
        artistOption :optionData.artistType,
        debut_date : null,
        language : 'ko' ,
        languageOption : optionData.language,

        biography_language: 'ko',
        biography : null ,
        biography_english : null,
        
        id_external : [],
        externalId : null,
        selectExternal : null ,
        externalOption : [
          'spotify',
          'apple',
          'melon'
        ],
        appleArtistOptions: [],
        appleArtistSelected: null,
        appleSearchLoading: false,
        appleSearchTimer: null,
        appleDirectInput: false,
        spotifyArtistOptions: [],
        spotifyArtistSelected: null,
        spotifySearchLoading: false,
        spotifySearchTimer: null,
        spotifyDirectInput: false,
        
        
        
        gridOptions :{ // 테이플 옵션
            onRowClicked: (event)=>{
                
            },
        },
        defaultColDef: {
          sortable: false,
          editable: false,
          resizable: true,
          suppressMenu: false,
          rowSelection:'single'
        },
        columnDefs: [
          {headerName: 'E-mail ID', field: 'email', filter: false,width: 220,},
          {headerName: '권리자명 (성 이름)', field: 'licensor.family_name', filter: false,width: 150,
            cellRenderer: (data) => {
              let fm = data.data.licensor.family_name ? data.data.licensor.family_name : '';
              let gm = data.data.licensor.given_name ? data.data.licensor.given_name : '' ;
              return fm +' '+ gm
          }},
          {headerName: '회사명', field: 'licensor.company', filter: false,width: 150,},
          
          {headerName: '정산화폐', field: 'licensor.currency', filter: false,width: 150,
            cellRenderer: (data) => {
              const type = {
                  'krw' : 'KRW',
                  'usd' : 'USD',
                  'eur' : 'EUR',
              }
              return type[data.value]
          }},
          {headerName: '사업자여부', field: 'licensor.entity', filter: false,width: 150, cellRenderer: (data) => {
              const type = {
                  'individual' : '개인',
                  'corporation' : '사업자',
              }
              return type[data.value]
          }},
          {headerName: '거주국가',  field: 'licensor.entity_address.country',  filter: false,width: 155,},
          {headerName: 'MIMS',  field: 'licensor.mims_account',  filter: false,width: 155,},
        ],
        // 라이센서 추가
        gridOptions5 :{ // 테이블 옵션 (같은 페이지에 있을때 공유해서 쓰면 에러)
          context: {
            componentParent: this
          },
          onGridReady: function (event) {
          },
          frameworkComponents : {
            btnSelect : BtnSelect
          }
        },
        columnDefsUser : [
          {headerName: '선택', field: 'id', filter: false,width: 100,
            cellRendererParams: {
              clicked: function(data) {
                this.context.componentParent.selectLicensor = [data]
                this.context.componentParent.closeModal('licensor')
              }
            },
            cellRenderer: 'btnSelect'
          },
          {headerName: 'E-mail ID', field: 'email', filter: false,width: 220,},
          {headerName: '권리자명 (성 이름)', field: 'licensor.family_name', filter: false,width: 150,
            cellRenderer: (data) => {
              let fm = data.data.licensor.family_name ? data.data.licensor.family_name : '';
              let gm = data.data.licensor.given_name ? data.data.licensor.given_name : '' ;
              return fm +' '+ gm
          }},
          {headerName: '회사명', field: 'licensor.company', filter: false,width: 150,},
          
          {headerName: '정산화폐', field: 'licensor.currency', filter: false,width: 150,
            cellRenderer: (data) => {
              const type = {
                  'krw' : 'KRW',
                  'usd' : 'USD',
                  'eur' : 'EUR',
              }
              return type[data.value]
          }},
          {headerName: '사업자여부', field: 'licensor.entity', filter: false,width: 150, cellRenderer: (data) => {
              const type = {
                  'individual' : '개인',
                  'corporation' : '사업자',
              }
              return type[data.value]
          }},
          {headerName: '거주국가',  field: 'licensor.entity_address.country',  filter: false,width: 155,},
          {headerName: 'MIMS',  field: 'licensor.mims_account',  filter: false,width: 155,},
        ],
        keywordType :  {label:'권리자명', value:'_name'},
        licensorKeyword : '',
        userList: {
          listData: [],                 
          pageSize: 10,                 
          currentPage: 1,
          totalPage: 0,                
        },
        files1 : [],          // 파일 데이터
        files2 : [],
        files3 : [],

        file1: {
          id :null,
          preview : ''
        },// profile
        file2: {
          id :null,
          preview : ''
        },
        file3: {
          id :null,
          preview : ''
        },

        accept:"",
        extensions:'',
        multiple: false,
        directory: false,
        drop: true,
        dropDirectory: true,
        addIndex: false,
        thread: 3,
        name: 'file',
        uploadAuto: false,
      }
    },
    mounted(){
    },
    computed: {
      
    },
    watch:{
     'userList.currentPage'(){
        this.getUserList()
      },
      selectExternal(val) {
        this.externalId = null;
        this.appleDirectInput = false;
        this.spotifyDirectInput = false;
        if (val !== 'apple') {
          this.appleArtistOptions = [];
          this.appleArtistSelected = null;
        }
        if (val !== 'spotify') {
          this.spotifyArtistOptions = [];
          this.spotifyArtistSelected = null;
        }
      },
    },
    methods: {
      openLicensor(){
        this.licensor =  {
          listData: [],                 
          pageSize: 0,                 
          currentPage: 1,
          totalPage: 0,                
        },
        //this.selectLicensor = null;
        this.keywordType =  {label:'권리자명', value:'_name'},
        this.licensorKeyword = '',
        this.openModal('licensor');
        this.getUserList()
      },
      getUserList(){
        const option = {
          sort: 'created_at',
          sortorder: 'desc',
          role : 'licensor',
          page: this.userList.currentPage-1 ,
          limit: this.userList.pageSize
        }
        if(this.keywordType && this.keywordType !='') {
            option[this.keywordType.value] = this.licensorKeyword
        }
        this.$store.dispatch('GETUSER', option)
        .then(result =>{
            this.userList.listData  = result.items // 권리자 목록
            //페이지 수
            const remainder = parseInt(result.filtered % this.userList.pageSize) > 0? 1: 0
            this.userList.totalPage = parseInt(result.filtered /this.userList.pageSize) + remainder

        }).catch(error=>{
            const status = error.response.status
            switch(status){
              case 401:
              this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
              break;
              default:
              break;
            }
        })
      },
     
      all_save(){
        
        this.closeModal('confirm')
        if(this.selectLicensor.length < 1) {
          this.alert({msg:'Licensor 매칭을 해주세요.'});
          return false
        }
        if(this.valCheck(this.display_name_language)){
          this.alert({msg:'아티스트명 언어를 선택해주세요.'});
          return false
        }
        if(this.valCheck(this.display_name)){
          this.alert({msg:'아티스트명을 입력해주세요.'});
          return false
        }
        // if(this.valCheck(this.display_name_english)){
        //   this.alert({msg:'아티스트명(번역)을 입력해주세요.'});
        //   return false
        // }
        // if(this.valCheck(this.artistType)){
        //   this.alert({msg:'아티스트 유형을 선택해주세요.'});
        //   return false
        // }
        // if(this.valCheck(this.nationality)){
        //   this.alert({msg:'아티스트국적을 선택해주세요.'});
        //   return false
        // }
        // if(this.valCheck(this.debut_date)){
        //   this.alert({msg:'데뷔년도를 선택해주세요.'});
        //   return false
        // }
        for (const key in this.name_multilang) {
          if(this.valCheck(this.name_multilang[key]) ){
            delete this.name_multilang[key]
          }else{
          }
        }
        for (const storeKey in this.name_export) {
          const inner = this.name_export[storeKey]
          if (inner && typeof inner === 'object') {
            for (const langKey in inner) {
              if (this.valCheck(inner[langKey])) {
                delete inner[langKey]
              }
            }
            if (Object.keys(inner).length === 0) {
              delete this.name_export[storeKey]
            }
          }
        }
    
        console.log(this.selectLicensor);
        let payload = {
          licensor_id : this.selectLicensor[0].licensor.id,
          "display_name": this.display_name,
          "display_name_language": this.display_name_language,
          "display_name_english": this.display_name_english,
          'name_multilang' : this.name_multilang,
          'name_export' : this.name_export,
          "profile_id": this.file1.id ? this.file1.id : null,
          "profile_yn": true,
          "image1_id": this.file2.id ? this.file2.id :null,
          "image2_id": this.file3.id ? this.file3.id : null,
          "debut_date": this.debut_date,
          "biography": this.biography ?this.biography : '',
          "biography_language": this.biography_language ,
          "biography_english": this.biography_english ? this.biography_english : '',
          "nationality": this.nationality,
          "is_various_artists": false,
          "sns": this.sns,
          id_external : this.id_external
          
        }
        if(this.artistType){
          payload['type'] = this.artistType
        }
        console.log(payload);
        this.$store.dispatch("POST_ARTIST", payload)
        .then(result =>{
          this.loadingHide();
          this.$vs.notify({text:'아티스트가 정상적으로 등록 되었습니다.',position:'top-center'})
          this.$router.push({path: '/artist'})
        }).catch(error =>{
          this.loadingHide();
          switch(error.response.status) {
            case 409:
              this.alert({
                msg : '이미 동일한 이름으로 등록된 아티스트가 있습니다.'
              }) 
              break;
            default:
              this.alert({msg:error})
              break;
          }
        })
      },
     
      inputFileUpload1(newFile, oldFile) {
        if (newFile && !oldFile) {
          console.log(newFile);
          // add
          if(newFile.file.type !== '' && newFile.file.type.indexOf('image') < 0){
          this.alert({msg: '이미지만 등록 가능합니다.'})
          return false
        }
          this.loadingShow()
          let file = newFile.file
          let reader = new FileReader
          reader.onload = e => {
            console.log(e);
            this.file1.remote_path = e.target.result
            this.$refs.upload1.active = true
          }
          reader.readAsDataURL(file)
        }
        if (newFile && oldFile) {

          // update
          
          if(Array.isArray(newFile.response)){
            
            this.file1 ={
              ...this.file1,
              id : newFile.response[0].id
            }
            console.log(this.file1)
            this.loadingHide()
          }
          
        }
        if (!newFile && oldFile) {
          // remove
          this.loadingHide()
          console.log('remove', oldFile)
        }
       
        
      },
      inputFileUpload2(newFile, oldFile) {
       if (newFile && !oldFile) {
          // add
          if(newFile.file.type !== '' && newFile.file.type.indexOf('image') < 0){
          this.alert({msg: '이미지만 등록 가능합니다.'})
          return false
        }
          this.loadingShow()
          let file = newFile.file
          let reader = new FileReader
          reader.onload = e => {
            this.file2.remote_path = e.target.result
            console.log(e)
            
            this.$refs.upload2.active = true
          }
          reader.readAsDataURL(file)
        }
        if (newFile && oldFile) {
          // update
          console.log(newFile)
          if(Array.isArray(newFile.response)){
            this.file2 ={
              ...this.file2,
              id : newFile.response[0].id
            }
            
            this.loadingHide()
          }
          
        }
        if (!newFile && oldFile) {
          // remove
          console.log('remove', oldFile)
        }
      },
      inputFileUpload3(newFile, oldFile) {
       if (newFile && !oldFile) {
          // add
          if(newFile.file.type !== '' && newFile.file.type.indexOf('image') < 0){
          this.alert({msg: '이미지만 등록 가능합니다.'})
          return false
        }
          this.loadingShow()
          let file = newFile.file
          let reader = new FileReader
          reader.onload = e => {
            this.file3.remote_path = e.target.result
            this.$refs.upload3.active = true
          }
          reader.readAsDataURL(file)
        }
        if (newFile && oldFile) {
          // update
          console.log(newFile)
          if(Array.isArray(newFile.response)){
            this.file3 ={
              ...this.file3,
              id : newFile.response[0].id
            }
            this.loadingHide()
          }
          
        }
        if (!newFile && oldFile) {
          // remove
          console.log('remove', oldFile)
        }
      },
      addSns(){
        let dd = {
          type : this.selectSns,
          url : this.snsUrl
        }
        if(!this.selectSns){
          this.alert({msg : 'URL 타입을 선택해주세요.'})
          return false;
        }
        if(this.valCheck(this.snsUrl)){
          this.alert({msg : 'URL를 입력해주세요.'})
          return false;
        }
        this.sns.push(dd);
      },
      removeSns(index){
        const array = this.sns;
        array.splice(index,1)
        this.sns = array
      },
      cancel(){
        this.confirm({
          title : '취소 확인',
          msg : `
            정말 나가시겠습니까?
          `,
          action : ()=>{
              this.$router.push({path: '/artist'})
          }
        })
        
      },
      updateLang(data){
        this.name_multilang = data
        this.$forceUpdate()

      },
      updateNameExport(data){
        this.name_export = data
        this.$forceUpdate()
      },

      addExternal(){
        let dd = {
          type : this.selectExternal,
          value : this.externalId
        }
        if(!this.selectExternal){
          this.alert({msg : '타입을 선택해주세요.'})
          return false;
        }
        if(this.valCheck(this.externalId)){
          this.alert({msg : 'ID를 입력해주세요.'})
          return false;
        }
        for( let i in this.id_external){
          if(this.id_external[i].type == this.selectExternal){
            this.alert({msg : '이미 등록된 타입입니다.'})
            return false
          }
        }
        
        this.id_external.push(dd);
        this.externalId = null
      },
      removeExternal(index){
        const array = this.id_external;
        array.splice(index,1)
        this.id_external = array
      },
      toggleAppleInputMode() {
        this.appleDirectInput = !this.appleDirectInput;
        this.externalId = null;
        this.appleArtistSelected = null;
        this.appleArtistOptions = [];
      },
      onAppleArtistSearch(query) {
        clearTimeout(this.appleSearchTimer);
        if (!query || query.length < 2) {
          this.appleArtistOptions = [];
          this.appleSearchLoading = false;
          return;
        }
        this.appleSearchLoading = true;
        this.appleSearchTimer = setTimeout(() => this.fetchAppleArtists(query), 300);
      },
      async fetchAppleArtists(query) {
        try {
          const response = await $api2.get('/proxy/apple-music/artists', { params: { term: query } });
          const artists = response.data?.data || [];
          this.appleArtistOptions = artists.map(a => ({
            id: a.id,
            label: `${a.name} (${a.id})`,
            thumbnail: a.thumbnail || null,
          }));
        } catch (e) {
          this.appleArtistOptions = [];
        } finally {
          this.appleSearchLoading = false;
        }
      },
      onAppleArtistSelect(option) {
        if (option) {
          this.externalId = option.id;
          this.appleArtistSelected = option;
        }
      },
      toggleSpotifyInputMode() {
        this.spotifyDirectInput = !this.spotifyDirectInput;
        this.externalId = null;
        this.spotifyArtistSelected = null;
        this.spotifyArtistOptions = [];
      },
      onSpotifyArtistSearch(query) {
        clearTimeout(this.spotifySearchTimer);
        if (!query || query.length < 2) {
          this.spotifyArtistOptions = [];
          this.spotifySearchLoading = false;
          return;
        }
        this.spotifySearchLoading = true;
        this.spotifySearchTimer = setTimeout(() => this.fetchSpotifyArtists(query), 300);
      },
      async fetchSpotifyArtists(query) {
        try {
          const response = await $api2.get('/proxy/spotify/artists', { params: { term: query } });
          const artists = response.data?.data || [];
          this.spotifyArtistOptions = artists.map(a => ({
            id: a.id,
            name: a.name,
            label: `${a.name} (${a.id})`,
            thumbnail: a.thumbnail || null,
          }));
        } catch (e) {
          this.spotifyArtistOptions = [];
        } finally {
          this.spotifySearchLoading = false;
        }
      },
      getExternalUrl(type, value) {
        if (type === 'spotify') {
          const id = value.replace('spotify:artist:', '');
          return `https://open.spotify.com/artist/${id}`;
        }
        if (type === 'apple') {
          return `https://music.apple.com/us/artist/${value}`;
        }
        return null;
      },
      onSpotifyArtistSelect(option) {
        if (option) {
          this.externalId = `spotify:artist:${option.id}`;
          this.spotifyArtistSelected = option;
        } else {
          this.externalId = null;
          this.spotifyArtistSelected = null;
        }
      },
    }
}
</script>

<style scoped>

</style>